import { API } from './api';
import { GW_SERVICES_PREFIXES } from '../constants/gateway';

const { INTERNAL } = GW_SERVICES_PREFIXES;

export const GetNews = (params: any) =>
  API.get(`/${INTERNAL}/api/v4/cabinet/news/`, params);
